import type { PredictionEvent } from '@/services/prediction/types'

/** Port of cdc-web `helpers/isRecurringEvent.ts`：duration > 0 的滚动周期事件。 */
export function isRecurringEvent(event?: Pick<PredictionEvent, 'duration'> | null) {
  return event?.duration != null && event.duration > 0
}

/**
 * Port of cdc-web `helpers/isCryptoEvent.ts`：键在 `event_kind_slug === 'crypto'`
 * ——不是 sub_asset_type（crypto futures 的 sub_asset_type 是 'predicts'，
 * 只有 futures kind 的 slug 是 'crypto'，精确命中需要特殊图标处理的集合）。
 */
export function isCryptoEvent(event?: Pick<PredictionEvent, 'event_kind_slug'> | null) {
  return event?.event_kind_slug === 'crypto'
}

/**
 * Port of cdc-web `helpers/usesBareIcon.ts`（OG-10214 收口 bare 政策）：
 * recurring strike（BTC/ETH 资产字形独占 40×40 位）与 crypto futures
 * （与 recurring crypto 卡同款 bare logo）用 bare 图标，其余 boxed。
 */
export function usesBareIcon(event?: Pick<PredictionEvent, 'duration' | 'event_kind_slug'> | null) {
  return isRecurringEvent(event) || isCryptoEvent(event)
}
